import Box from '@mui/material/Box';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import Checkbox from '../../../../../components/molecules/Checkbox';
import { StyledFontAwesomeIconMui5 } from '../../../../../components/atoms/FontAwesomeIcon';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons/faCircleCheck';

const Label = styled('span')`
  color: black;
  font-size: 1rem;
  font-weight: bold;
  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
`;

const Icon = styled(StyledFontAwesomeIconMui5)`
  filter: drop-shadow(0 3px 10px rgba(0, 0, 0, 0.5));
  margin-right: 8px;
`;

const Container = styled(Box)(
  ({ theme }) => `
  &.MuiBox-root {
    
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    background-color: #F8D85A;
    /*noinspection CssInvalidPropertyValue*/margin: ${theme.spacing(1, -2)};
    /*noinspection CssInvalidPropertyValue*/padding: ${theme.spacing(2, 2)};
    margin-top: 0;
    margin-bottom: 0;
    color: black;
  }`,
);

type TariffFreeDealsFilterType = {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
};

export const TariffFreeDealsFilter: FC<TariffFreeDealsFilterType> = ({
  setFilterValue,
  disabled,
}) => {
  const { filters } = useFilters();
  const [isEnabled, setIsEnabled] = useState(filters.tariff_free_deals);

  useEffect(() => {
    if (isEnabled !== filters.tariff_free_deals) {
      setIsEnabled(filters.tariff_free_deals);
    }
  }, [filters.tariff_free_deals, isEnabled]);

  const toggleFilter = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setFilterValue('tariff_free_deals', isChecked);
    setIsEnabled(isChecked);
  };

  return (
    <Container>
      <Label>
        <Icon icon={faCircleCheck} color='inherit' />
        Tariff-Free Deals
      </Label>
      <Checkbox
        withLabel={false}
        color='default'
        fullWidth={false}
        disabled={disabled}
        onChange={toggleFilter}
        checked={isEnabled}
      />
    </Container>
  );
};
